/**
 * @generated SignedSource<<f100f23fa6d892202a98fab82d464c10>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModal_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContent_viewer">;
  readonly " $fragmentType": "NftPdpBidModal_viewer";
};
export type NftPdpBidModal_viewer$key = {
  readonly " $data"?: NftPdpBidModal_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModal_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpBidModal_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpBidModalContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "b299808debe7baedbd0b42e6e23c6be3";

export default node;
